<template>
  <div class="d-flex">
    <v-checkbox
        v-model="checkboxActive"
        v-show="printIsActive"
        :disabled="!isPrintable"
    />

    <v-card class="mb-3 flex-grow-1">
      <v-alert v-if="isPrintNotification" border="top" icon="mdi-alert"
               type="warning">{{ properties.policy_2.message }}</v-alert>
      <div>
        <v-card-title>{{ konzert.konzertdaten.eventdata.name }}</v-card-title>
        <v-card-subtitle>
          <span v-if="konzert.konzertdaten.eventdata.policy_id === 4">
            Noch in Abklärung
          </span>
          <span v-else>
            {{ konzert.konzertdaten.vorst_datum_text }}
          </span>
        </v-card-subtitle>
        <v-card-text v-if="konzert.konzertdaten.zyklus_name">{{ konzert.konzertdaten.zyklus_name }}</v-card-text>

        <v-card-text class="py-0">
          <p>
            <span v-if="konzert.konzertdaten.eventdata.venue">
              {{ konzert.konzertdaten.eventdata.venue.name }}
            </span>
            <br v-if="konzert.konzertdaten.vorst_extra_info" />
            <span v-html="konzert.konzertdaten.vorst_extra_info"></span>
            <br v-if="konzert.konzertdaten.eventdata.comment_customer || konzert.tickets[0].comment_customer_if_marked" />
            <span v-if="konzert.konzertdaten.eventdata.comment_customer && konzert.konzertdaten.eventdata.comment_customer !== 'null'">
              <br />
              {{ konzert.konzertdaten.eventdata.comment_customer }}
            </span>
            <span v-if="konzert.tickets[0].comment_customer_if_marked">
              <br />
              {{ konzert.tickets[0].comment_customer_if_marked }}
            </span>
            <span v-if="konzert.konzertdaten.eventdata.policy_id === 3">
              <br /><br />
              Für diese Veranstaltung sind Sitzplatzanzeige und Kartendruck aktuell nicht verfügbar.
            </span>
            <span v-if="konzert.konzertdaten.eventdata.policy_id === 4">
              <br /><br />
              Wir sind immer noch bemüht, für diese Veranstaltung einen Ersatztermin zu finden.<br />
              Sie werden sobald wie möglich über den neuen Termin informiert.
            </span>
          </p>
        </v-card-text>
      </div>

      <div class="d-flex justify-md-end flex-column flex-sm-row my-5">
        <v-btn
          v-if="konzert.konzertdaten.eventdata.url"
          class="mx-5 my-sm-5"
          @click.stop="openInNewTab(konzert.konzertdaten.eventdata.url)"
          target="_blank"
        >
          <v-icon left>mdi-open-in-new</v-icon>Link zur
          Vorstellungsseite
        </v-btn>
        <v-btn class="mx-5 mt-3 mr-sm-5 my-sm-5" :disabled="konzert.konzertdaten.eventdata.policy_id === 3 || konzert.konzertdaten.eventdata.policy_id === 4" @click.stop="navigateToSingleView">
          <v-icon left>mdi-ticket</v-icon>Tickets anzeigen
        </v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import propertyData from "@/assets/properties.json"

export default {
  props: {
    konzert: Object
  },
  data: () => ({
     properties: propertyData
  }),
  computed: {
    ...mapGetters(["printIsActive", "shouldItemBeSelected"]),
    checkboxActive: {
      get() {
        return this.shouldItemBeSelected(this.konzert.konzertdaten.vorst_nr);
      },
      set(event) {
        this.checkboxChange(event);
      }
    },
    isPrintable() {
      // only tickets with policy 1 are printable
      return this.konzert.konzertdaten.eventdata.policy_id === 1
    },
    isPrintNotification() {
      // only tickets woth policy 2 have print notification
      return this.konzert.konzertdaten.eventdata.policy_id === 2
    }
  },
  methods: {
    ...mapActions(["changePrintState"]),
    checkboxChange(value) {
      const action = value ? "ADD" : "REMOVE";
      const concert = this.konzert;
      this.changePrintState({ action, concert });
    },
    handleCardClick() {
      if (this.printIsActive) {
        this.checkboxChange(!this.checkboxActive);
      } else {
        this.navigateToSingleView();
      }
    },
    navigateToSingleView() {
      this.$router.push(`/drucken/${this.konzert.konzertdaten.vorst_nr}`);
    },
    openInNewTab(link) {
      window.open(link, "_blank");
    }
  }
};
</script>

<style></style>
